module.exports = __webpack_public_path__ + "img/stone1.f0daa628.png";